/**
 * Decode a JWT token without verification
 * Note: This only decodes the payload, it does NOT verify the signature
 * Use this only for reading non-sensitive claims from trusted sources
 */
export function decodeJWT(token) {
  if (!token) return null;

  try {
    // JWT format: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    
    // Base64 URL decode
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
}

/**
 * Get the product ID from the JWT token stored in localStorage
 */
export function getProductIdFromToken() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const payload = decodeJWT(token);
  if (!payload) return null;

  // Return the productId from the token payload
  // Adjust the property name based on your actual JWT structure
  return payload.productId || payload.product_id || null;
}

/**
 * Get user profile data from JWT token
 */
export function getUserProfileFromToken() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const payload = decodeJWT(token);
  if (!payload) return null;

  // Return a user profile object similar to what the API returns
  return {
    productId: payload.productId || payload.product_id || null,
    uploadCount: payload.uploadCount || payload.upload_count || undefined,
    uploadResetDate: payload.uploadResetDate || payload.upload_reset_date || undefined,
    // Add any other fields that might be in the JWT
    ...payload
  };
}

